var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col d-flex flex-column text-truncate"},[_c('font-awesome-icon',{class:_vm.to_large_icon ? 'large' : 'normal',attrs:{"icon":['fas', _vm.awesome_icon]},on:{"click":_vm.doClick}}),_c('span',{class:_vm.title_class},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }